import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  position: absolute;
  width: 100%;
`

export const SplitViewListingSectionContainer = styled.div`
  overflow-y: scroll;
  width: 70%;
`

export const SplitViewMapSectionContainer = styled.div`
  height: 100%;
  width: 30%;
`

export const SingleViewContainer = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
`
